import { action } from 'satcheljs';
import type { ExtendedPalette } from '../store/schema/ExtendedTheme';

export interface CHANGE_FABRIC_THEMEActionMessage {
    themeSymbols: Partial<ExtendedPalette>;
    isDarkTheme: boolean;
}
const defaultExport: (
    themeSymbols: Partial<ExtendedPalette>,
    isDarkTheme: boolean
) => CHANGE_FABRIC_THEMEActionMessage = action(
    'CHANGE_FABRIC_THEME',
    (
        themeSymbols: Partial<ExtendedPalette>,
        isDarkTheme: boolean
    ): CHANGE_FABRIC_THEMEActionMessage => ({
        themeSymbols,
        isDarkTheme,
    })
);
export default defaultExport;
